/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

// TODO Unit testy.
/**
 * Zdroj zobrazování médií v podobě HTML video elementu.
 * Zdrojový element je obalený do rámujícího div a s ním vložen na určené místo do DOM.
 * @implements {ViewerSource}
 */
class ViewerSourceVideo {
  /**
   * Vytvoří instanci.
   * @param {ViewerFrameFactory} frameFactory
   * @param {HTMLElement} parentEl Rodičovský element, určený pro vkládání elementů zdroje.
   * @returns {ViewerSourceVideo} Nová instance.
   */
  constructor(frameFactory, parentEl) {
    if (!isObject(parentEl)) {
      // Zakázáno vytváření bez rodičovského elementu, jinak nemá příprava objektů v bazénu smysl.
      throw new TypeError(`Invalid parent element ${parentEl}.`);
    }
    // TODO Vyčlenit vytvoření elementů do samostatné public metody, než je mít v konstruktoru?
    const frame = frameFactory.create();
    const frameEl = frame.getEl();
    const el = document.createElement('video');
    frameEl.appendChild(el);
    parentEl.appendChild(frameEl);
    this.el = el;
    this.frame = frame;
    this.parentEl = parentEl;
  }

  /** @inheritdoc */
  destroy() {
    // Uvolnění video elementu dle doporučení ze SO.
    // https://stackoverflow.com/questions/3258587/how-to-properly-unload-destroy-a-video-element
    // TODO Je lepší, než prosté odebrání z DOM. Přesto dochází k paměťovým únikům. Používat jen v případě nutnosti.
    const { el } = this;
    el.pause();
    el.removeAttribute('src');
    el.load();
    // Odebrání frame elementu z DOM.
    const frameEl = this.frame.getEl();
    this.parentEl.removeChild(frameEl);
  }

  /** @inheritdoc */
  getEl() {
    const { el } = this;
    if (isNil(el)) {
      throw new TypeError('Missing element.');
    }
    return el;
  }

  /** @inheritdoc */
  getFrame() {
    return this.frame;
  }

  /** @inheritdoc */
  setParentEl(parentEl) {
    if (!isObject(parentEl)) {
      throw new TypeError(`Invalid parent element ${parentEl}.`);
    }
    if (parentEl === this.parentEl) {
      // Pokud se rodičovský element nezmění, tak se přesun neprovádí.
      return;
    }
    // Přesun elementu do nového rodiče.
    // TODO Platformově specifické prolínače. Pro Samsung možno přidat omezení nebo ošetření přesunu.
    // - Příklad speciální implementace, která by nedovolila přesun elementu?
    // - `AdapterTizenSssp4.ViewerSourceVideo`
    const frameEl = this.frame.getEl();
    parentEl.appendChild(frameEl);
    this.parentEl = parentEl;
  }
}

export default ViewerSourceVideo;
